import React from "react";
import { Box, Typography } from '@mui/material';


const StatsCard = (props) => {


    return(
        <div className="card-container bg-white rounded-xl w-full p-5 my-2">
            <div className="flex items-center justify-start">
                <Box className={`flex justify-center items-center rounded-full p-4`} sx={{bgcolor: props.bgColor}}>
                    <img src={props.icon} alt={`${props.title} icon`} className="w-8 h-8"/>
                </Box>
                <div className="flex flex-col ml-7">
                    <Typography component={'div'} variant="text18Light" className="truncate min-h-[1.5rem]">{props.title}</Typography>
                    <Typography component={'div'} variant="textheader3" className="truncate">{props.count}</Typography>
                </div>
            </div>
        </div>
    )
}

export default StatsCard;